export default __webpack_public_path__ + "static/media/helm_of_the_wicked.805b744d.jpg";